import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import adminReducer from './adminSlice';
import centralServicesReducer from './centralServicesSlice';
import configReducer from './configSlice';
import doctorsReducer from './doctorsSlice';
import groupInfoReducer from './groupInfoSlice';
import imagingReducer from './imagingSlice';
import requestsReducer from './requestsSlice';
import schedulesReducer from './schedulesSlice';

const store = configureStore({
  reducer: {
    doctors: doctorsReducer,
    admins: adminReducer,
    schedules: schedulesReducer,
    groupInfo: groupInfoReducer,
    config: configReducer,
    centralServices: centralServicesReducer,
    imaging: imagingReducer,
    requests: requestsReducer,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
